import Vue from 'vue'
import Vuex  from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({



  state: {
    token: "",
    userinfo: "",
    username:"",
    globalVariable: 0

  },
  mutations: {
    updateGlobalVariable(state, newValue) {
      state.globalVariable = newValue;
    },
    set_token(state, token) {
      state.token = token;
      sessionStorage.setItem("token", token);
    },
    del_token(state) {
      state.token = "";
      sessionStorage.removeItem("token");
    },
    setUserInfo(state, userinfo_Data) {
      state.userinfo = userinfo_Data
      sessionStorage.setItem("userinfo_Data", userinfo_Data);
    },
   
  }
})


export default store



// WEBPACK FOOTER //
// ./src/store/store.js